import React, { Fragment, memo, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { PATH } from "utils/constants";
// import { PAGENAME } from "utils/constants";
import styles from "./HomeLayout.module.scss";
// import Button from "../../components/Button";
import { useNavigate } from "react-router-dom";
// import arrow from "assets/png/arrow.png";
import logout from "assets/png/logout.png";
import toast from "components/shared/toast/toast";
import Button from "components/shared/button/Button";
import { privatePost } from "services/privateRequest";
import SearchField from "components/shared/searchfield/SearchField";
import SearchBar from "./SearchBar";
import { UseSelector, useSelector } from "react-redux/es/hooks/useSelector";
import AVATAR from "../../../assets/png/profile.png"
// import { LOGOUT } from "services/apiEndpoints";

const TopBar = (props) => {
  const { roles } = useSelector((state) => state.stock)
  const [logoutModel, setLogoutModel] = useState(false);
  const [currentPath, setCurrentPath] = useState({});
  const location = useLocation();
  const navigate = useNavigate();

  const email = localStorage.getItem("email")
    ? localStorage.getItem("email")
    : "user@gmail.com";

  const pageName = useMemo(() => {
    let temp = {}
    Object.values(PATH).filter(x => x.private).forEach(portal => {
      const obj = Object.values(portal.children).find(pathData => pathData.path === location.pathname)
      if (obj)
        temp = obj
    })
    setCurrentPath(temp)
    return (temp?.pageName || "") + (temp?.logs ? " - Report Logs" : "")
    // switch (pathName) {
    //   case PATH.BALANCE_SHEET || "/balance-generate":
    //     return PAGENAME.BALANCESHEET + " - Report Logs";

    //   case PATH.CASHFLOW_SHEET:
    //     return PAGENAME.CASHFLOWSHEET + " - Report Logs";

    //   case PATH.CONFIGURE:
    //     return PAGENAME.CONFIGURE;

    //   case PATH.BALANCE_GENERATE:
    //     return PAGENAME.BALANCESHEET + " - Report Logs";

    //   case PATH.CASHFLOW_GENERATE:
    //     return PAGENAME.CASHFLOWSHEET + " - Report Logs";

    //   default:
    //     break;
    // }
  }, [location]);

  // const handleLogout = async () => {
  //   await privatePost(LOGOUT)
  //   localStorage.clear()
  //   toast.success("Logout Successful")
  //   navigate("/login")
  // };

  // useEffect(() => {
  //   document.body.addEventListener("click", () => {
  //     setLogoutModel(false);
  //   });
  // });

  return (
    <Fragment>
      <div className={styles.topBarContainer}>
        <div className={styles.leftSide}>
          <p className={styles.pageName}>{pageName}</p>
        </div>

        <div className={styles.rightSide}>
          {currentPath?.showGenerateBtn && (
            <Button
              className={styles.generate}
              onClick={() => navigate(location.pathname + "/generate")}
              navigateTo={props?.navigateTo}
              label="Generate"
            />
          )}
          {roles?.tracker && roles?.trend ? location.pathname == "/stock/logs" ? <div className={styles.tracker_top}>
            <div className={styles.username}>
              <div className={styles.profile_img}>
                <img src={AVATAR} style={{ width: "100%", height: "100%" }} /></div> {localStorage.getItem("username")}
            </div>
            <Button
              className={styles.generate}
              onClick={() => navigate("/stock")}
              label="Generate"
            />

          </div> : location.pathname == "/stock" ? <div className={styles.tracker_top}>
            <div className={styles.username}>
              <div className={styles.profile_img}>
                <img src={AVATAR} style={{ width: "100%", height: "100%" }} /></div> {localStorage.getItem("username")}
            </div>
          </div> : <SearchBar /> :
            roles?.trend ? <SearchBar /> : location.pathname == "/stock" ?
              <div className={styles.tracker_top}>
                <div className={styles.username}>
                  <div className={styles.profile_img}>
                    <img src={AVATAR} style={{ width: "100%", height: "100%" }} /></div> {localStorage.getItem("username")}
                </div>
              </div>
              : <div className={styles.tracker_top}>
                <div className={styles.username}>
                  <div className={styles.profile_img}>
                    <img src={AVATAR} style={{ width: "100%", height: "100%" }} /></div> {localStorage.getItem("username")}
                </div>
                <Button
                  className={styles.generate}
                  onClick={() => navigate("/stock")}
                  label="Generate"
                />

              </div>
          }



          {/* <div className={styles.logoutCircle}>
            <span>{email}</span>
            <span
              onClick={(e) => {
                e.stopPropagation();
                setLogoutModel(!logoutModel);
              }}
              className={styles.firstLetter}
            >
              {email.charAt(0).toUpperCase()}
            </span>
          </div> */}
        </div>
      </div>
      {/* {logoutModel && (
        <div>
          <div className={styles.logoutButton}>
            <img className={styles.logoutIcon} src={logout} alt="logout" />
            <Button
              onClick={handleLogout}
              className={styles.logoutBtn}
              outline={true}
              label="Logout"
            />
          </div>
        </div>
      )} */}
      {/* <div className={styles.search}>
        <SearchField
          placeholder="search stocks" />
      </div> */}

    </Fragment>
  );
};

export default memo(TopBar);
